import { render, staticRenderFns } from "./dailyHireWorkAdd.vue?vue&type=template&id=2bdf4fae&scoped=true&"
import script from "./dailyHireWorkAdd.vue?vue&type=script&lang=js&"
export * from "./dailyHireWorkAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdf4fae",
  null
  
)

export default component.exports